/**
 * Minimal Auth Utilities for Special Cases
 * 
 * Use these ONLY for:
 * - Streaming responses (Server-Sent Events, ReadableStream) 
 * - Special cases where fetch() is required instead of axios
 * 
 * For all other cases, use apiClient (axios) which has automatic auth.
 */

/**
 * Create authentication headers for fetch() calls
 * 
 * Accepts token and subscription ID as parameters (no localStorage).
 * Tokens should be obtained using the useIdentity hook's getAccessToken() method.
 * 
 * @param token - Access token (get from useIdentity().getAccessToken())
 * @param subscriptionId - Optional subscription ID for multi-tenancy
 * @param additionalHeaders - Optional additional headers to merge
 * @returns HeadersInit object with authentication
 */
export function createAuthHeaders(
  token: string,
  subscriptionId?: string | null,
  additionalHeaders?: Record<string, string>
): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
    ...additionalHeaders,
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  if (subscriptionId) {
    headers['X-Subscription-Id'] = subscriptionId;
  }
  
  return headers;
}
